/* eslint-disable import/first */
import React, { useState } from 'react';
import {
  Button,
  Paper,
  Grid,
  Typography,
  Divider,
  Select,
  MenuItem,
  TextareaAutosize,
} from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
import BackButton from '../../components/BackButton';
import StarRating from '../../components/StarRating';
import thankyou from './images/thankyou.svg';
import css from './index.module.scss';
import { Redux, Slices } from 'spwa-ui-library';

import { FormattedMessage, useIntl } from 'react-intl';
import AngryFace from './images/angry.png';
import SadFace from './images/sad.png';
import SmileFace from './images/smile.png';
import HappyFace from './images/happy.png';
import InLoveFace from './images/in-love.png';

const { useSelector, useDispatch } = Redux;
const { sendFeedBack } = Slices.orderSlice;

const FeedbackInfo = ({
  onDrawerHandling,
  smileIndex,
  submitStarRating,
  sentFeedback,
  ordrId,
  setShowThankyou = () => {},
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const config = useSelector((state) => state.config?.data?.data);
  const smileRate = location?.state?.smileRating || smileIndex;
  const intl = useIntl();
  const [changedRating, setChangedRating] = useState(false);

  const feedbackData = {
    oneStar: {
      rating: 1,
      icon: AngryFace,
      heading: intl.formatMessage({ id: 'feedback_heading_1' }),
      showMessageBox: true,
    },
    twoStar: {
      rating: 2,
      icon: SadFace,
      heading: intl.formatMessage({ id: 'feedback_heading_2' }),
      showMessageBox: true,
    },
    threeStar: {
      rating: 3,
      icon: SmileFace,
      heading: intl.formatMessage({ id: 'feedback_heading_3' }),
      showMessageBox: true,
    },
    fourStar: {
      rating: 4,
      icon: HappyFace,
      heading: intl.formatMessage({ id: 'feedback_heading_4' }),
      showMessageBox: true,
    },
    fiveStar: {
      rating: 5,
      icon: changedRating ? InLoveFace : thankyou,
      heading: intl.formatMessage({ id: 'feedback_heading_5' }),
      showMessageBox: false,
    },
  };

  const feedbackStarData = Object.values(feedbackData).find((f) => f.rating == smileRate);
  const feedbackReasonObject = JSON.parse(JSON.stringify(config?.constants?.feedbackReasons)) || {};

  const feedbackReasons = [
    intl.formatMessage({ id: 'feedback_select_reason' }),
    ...feedbackReasonObject[intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)],
  ];

  const [feedbackReason, setFeedbackReason] = useState(feedbackReasons[0]);
  const [feedbackDesc, setFeedbackDesc] = useState('');

  const submitFeedback = () => {
    let payload = {
      rating: smileIndex,
      mdbOrderId: ordrId || null,
    };
    if (feedbackDesc !== '') {
      payload.description = feedbackDesc;
      payload.reason = feedbackReason;
    }
    dispatch(sendFeedBack(payload)).then((res) => {});
    if (onDrawerHandling) {
      onDrawerHandling();
    }
    if (payload.rating !== 5) {
      setShowThankyou(true);
    }
    // debugger;
    let rateArray = JSON.parse(window.localStorage.getItem('_fed')) || [];
    rateArray.push(ordrId);
    if (rateArray.length > 5) {
      rateArray.shift();
    }
    window.localStorage.setItem('_fed', JSON.stringify(rateArray));
    if (sentFeedback) {
      sentFeedback((prev) => !prev);
    }
  };

  const closeHandler = () => {
    // submitFeedback();
    if (location.pathname === `/${intl.locale}/feedback/sent`) {
      navigate(`/${intl.locale}/home`, { replace: true });
    }
    if (onDrawerHandling) {
      onDrawerHandling();
    }
  };

  return (
    <Paper variant="outlined" square className={css.drawerBoundry}>
      <Grid className={css.DrawerData}>
        <div className={css.heading}>
          <FormattedMessage id="navigation_feedback" defaultMessage="Feedback" />
        </div>
        <div className={css.backButtonContainer}>
          <BackButton type="cross" handleBack={closeHandler} />
        </div>
        <Grid className={css.tnxImgProp}>
          <img src={feedbackStarData?.icon} alt="" />
        </Grid>

        {!(feedbackStarData.rating == 5 && !changedRating) ? (
          <>
            <Grid>
              <Typography className={css.feedbackHeading}>{feedbackStarData?.heading}</Typography>
            </Grid>
            <Grid onClick={() => setChangedRating(true)}>
              <StarRating
                submitStarRating={submitStarRating}
                smileIndex={smileRate}
                showInline={true}
              />
            </Grid>
            <Grid>
              <Typography className={css.typography}>
                <FormattedMessage
                  id="feedback_subheading"
                  defaultMessage="Your feedback is valuable to us"
                />
              </Typography>
            </Grid>
          </>
        ) : (
          <Typography className={css.feedbackHeading}>
            <FormattedMessage id="thanks_for_rating" defaultMessage="Thanks For Rating Us" />
          </Typography>
        )}

        {(feedbackStarData.showMessageBox || changedRating) && (
          <Grid className={css.feedbackInputContainer}>
            <Divider />
            <Grid>
              <Grid>
                <Typography className={css.feedbackInputHeading}>
                  <FormattedMessage
                    id={'feedback_input_heading'}
                    defaultMessage={'Tell us what you love or where we can improve'}
                  />
                </Typography>
              </Grid>

              <Grid>
                <Select
                  MenuProps={{
                    style: { zIndex: 9999 },
                  }}
                  className={css.feedbackSelectReason}
                  value={feedbackReason}
                  onChange={(e) => {
                    setFeedbackReason(e.target.value);
                  }}
                >
                  {feedbackReasons?.map((reason, i) => (
                    <MenuItem key={i} value={reason}>
                      {reason}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid>
                <TextareaAutosize
                  value={feedbackDesc}
                  className={css.feedbackDescription}
                  onChange={(e) => setFeedbackDesc(e.target.value)}
                  lass={css.inputDescription}
                  aria-label=""
                  placeholder={intl.formatMessage({ id: 'feedback_input_placeholder' })}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid className={css.buttonArea}>
          <Button className={css.tnxButton} onClick={submitFeedback}>
            <FormattedMessage id="gotit" defaultMessage="GOT IT" />
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FeedbackInfo;
